import { render, staticRenderFns } from "./Three.vue?vue&type=template&id=975b9112&scoped=true"
var script = {}
import style0 from "./Three.vue?vue&type=style&index=0&id=975b9112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975b9112",
  null
  
)

export default component.exports